<template>
  <div>
    <div class="thank-you-container">
      <p style="font-weight: 600; font-size: 35px; color: #00346b; margin: 0px 0px 20px;">
        Thank you for supporting Teach Florida.
      </p>
    </div>
  </div>
</template>
<style scoped>
.thank-you-container {
  padding: 20px;
  text-align: center;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
}
</style>
